import React from 'react';
import PropTypes from 'prop-types';
import ProgressOnTable from './ProgressOnTable';
import NumberUtils from '../../utils/NumberUtils';

function BudgetTableRowTemplate(props) {
  const { rowData, metadata, customClick } = props;
  const { target_amount: budgetValue, current_month: currentMonth } = rowData;

  const getColumnData = () => {
    switch (metadata.columnName) {
      case 'name': {
        return (
          <div
            className={`spendings__tag_name${
              rowData.archived || rowData.joint ? ' column-fade' : ''
            }`}
          >
            <a onClick={() => customClick(rowData.name, rowData)}>
              <span>{rowData.name}</span>
            </a>
          </div>
        );
      }
      case 'current_month': {
        return NumberUtils.appendCurrency('{}', currentMonth);
      }
      case 'progress': {
        return rowData.archived || rowData.joint ? null : (
          <ProgressOnTable {...props} />
        );
      }
      case 'target_amount': {
        return budgetValue === 0
          ? '-'
          : NumberUtils.appendCurrency('{}', budgetValue);
      }
      case 'message': {
        return rowData.message;
      }
      default: {
        return null;
      }
    }
  };

  return <div className="enabled">{getColumnData()}</div>;
}

BudgetTableRowTemplate.propTypes = {
  rowData: PropTypes.object,
  metadata: PropTypes.object,
  customClick: PropTypes.func,
  content: PropTypes.object,
};

export { BudgetTableRowTemplate };
